module.exports = __webpack_public_path__ + "img/Left Window.034ea0a3.png";